import { TokenUser } from './token-user';

export class Mentor extends TokenUser {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    profilePhotoUrl?: string;
    appUserId?: number;
}